import * as React from "react";
import {BigCalendarDetail} from "./BigCalendarDetail";
import {EventState} from "./interfaces/EventState";
import {EventHelper} from "./EventHelper";
import {LoaderSpinner} from "./LoaderSpinner";

interface ListCalendarProps {
    events: any[];
    calendarId: string;
}

interface ListCalendarState {
    events: EventState[];
    loading: boolean;
}

/**
 * List calendar events.
 */
export class ListCalendar extends React.Component<ListCalendarProps, ListCalendarState> {

    state: {
        events: EventState[],
        loading: boolean,
    };

    private bigCalendarDetail: BigCalendarDetail;

    constructor(props: any) {
        super(props);

        this.state = {
            events: this.props.events,
            loading: false
        }
    }

    render() {
        return <div className={this.state.loading ? 'bigCalendarLoading' : ''}>

            {this.state.events.length > 0 && this.state.events.map(event => (
                <div key={event.id} className={"calendarList"} onClick={() => {
                    this.setState({
                        loading: true
                    });
                    this.bigCalendarDetail.setEventDetails(event, this.props.calendarId);
                }}>
                    <div key={event.id} className={"calendarListHeader"}>
                        <h4>{event.title}</h4>
                    </div>
                    <div className={"calendarListContentContainer"}>
                        <div className={"calendarListContent"}>
                            <span className={"calendarListBadge"}>
                                <i className={"fa fa-clock-o"}/>
                                {EventHelper.getDateString(event.start, event.end)}
                            </span>
                        </div>
                        {event.location && (<div className={"calendarListContent"}>
                            <span className={"calendarListBadge"}>
                                <i className={"fa fa-location-arrow"}/>
                                {event.location}
                            </span>
                        </div>)}
                    </div>
                </div>

            ))}
            {this.state.events.length === 0 && (
                <div className={"calendarNoEvents"}>
                    <h4>{"Keine Events vorhanden"}</h4>
                </div>
            )}
            <BigCalendarDetail showDetails={true} ref={(ref) => this.bigCalendarDetail = ref} onLoaded={() => {
                this.setState({loading: false});
            }}/>
            <div className={"loadingSpinner"}>
                {this.state.loading &&
                <LoaderSpinner/>
                }
            </div>
        </div>
    }
}
